import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=539d5974&scoped=true&"
import script from "./BulletinBoard.vue?vue&type=script&lang=js&"
export * from "./BulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./BulletinBoard.vue?vue&type=style&index=0&id=539d5974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d5974",
  null
  
)

export default component.exports